<template>
    <div>
        <el-card>
            <div class="tableBox">
                <div>
                    <div>
                        <span>细化变更</span>
                        <span>变更RFC状态实时汇总</span>
                    </div>
                    <img src="../../../../assets/icon_logo.png">
                </div>
                <div>
                    <div>
                        <div style="position:relative;height:20px;">
                            <div class="helpDiv" style="position: absolute;top:-20px">
                                <b class="helpI"></b>
                                <a href="https://wiki.autoai.com/pages/viewpage.action?pageId=26157039"
                                target="_blank"
                                class="helpA">
                                    帮助指引
                                </a>
                            </div>
                        </div>
                        <el-form :inline="true" class="search-form">
                            <el-form-item label="">
                                <el-date-picker
                                    ref="dataPicker"
                                    @change="changeData"
                                    v-model="value"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                            <el-button type="primary" @click="selectData">修改时间</el-button>
                            <el-button type="primary" @click="getExcel">导出excel</el-button>
                        </el-form>
                    </div>
                    <div class="tableClass">
                        <div>
                            <el-table id="table-content"
                                :data="tableData"
                                border>
                                <el-table-column prop="status" label=""></el-table-column>
                                <el-table-column prop="" label="优先级">
                                    <el-table-column prop="priority_emergence" label="紧急" sortable :sort-orders="sortList"></el-table-column>
                                    <el-table-column prop="priority_heigh" label="高" sortable :sort-orders="sortList"></el-table-column>
                                    <el-table-column prop="priority_secondary" label="中" sortable :sort-orders="sortList"></el-table-column>
                                    <el-table-column prop="priority_low" label="低" sortable :sort-orders="sortList"></el-table-column>
                                </el-table-column>
                                <el-table-column prop="" label="风险等级">
                                    <el-table-column prop="emergency_emergency" label="重大" sortable :sort-orders="sortList"></el-table-column>
                                    <el-table-column prop="emergency_heigh" label="高" sortable :sort-orders="sortList"></el-table-column>
                                    <el-table-column prop="emergency_secondary" label="中" sortable :sort-orders="sortList"></el-table-column>
                                    <el-table-column prop="emergency_low" label="低" sortable :sort-orders="sortList"></el-table-column>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div>
                    <div>
                        <span>生成时间:</span>
                        <span>{{getMes.generateTime}}</span>
                    </div>
                    <span>itsmops.autoai.com</span>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from '../reportRefining.service';
    import { export_json_to_excel } from '../../../../core/utils/Export2Excel';
    export default {
        data: function () {
            return {
                tableData: [],
                sortList:['descending', 'ascending'],
                value:'',
                getMes:{},
            }
        },
        mounted(){
            this.value = services.getDefaultData();
            this.getData();
        },
        methods:{
            getExcel(){
                services.exportToExcel(`变更RFC状态实时汇总${this.value[0]}—${this.value[1]}`);
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            getData(){//获取数据
                let params = {
                    startTime: this.value[0],
                    stopTime: this.value[1],
                }
                services.changeGroupStatusCountPriorityEmergencyList(params).then(res=>{
                    this.getMes = res;
                    this.tableData = res.tableData;
                })
            },
            selectData(){//点击修改日期 日期控件自动聚焦
                let selData = this.$refs.dataPicker;
                selData.focus();
            },
            changeData(){//选择日期
                this.getData();
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
